import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { AppDataProvider } from './context/AppDataContext';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import Manager from './pages/Manager';
import Operator from './pages/Operator';
import Dashboard from './pages/Dashboard';
import OvenStatus from './pages/OvenStatus';
import Vision from './pages/Vision';
import Logs from './pages/Logs';
import Sensors from './pages/Sensors';
import CameraSettings from './pages/CameraSettings';
import AppLayout from './components/AppLayout';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppDataProvider>
        <Routes>
          <Route path="/login" element={<Login />} />

          <Route
            path="/manager"
            element={
              <ProtectedRoute>
                <AppLayout>
                  <Manager />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/operator/:machineId"
            element={
              <ProtectedRoute>
                <AppLayout>
                  <Operator />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          <Route path="/operator" element={<Navigate to="/operator/1" replace />} />
          <Route
            path="/ovens"
            element={
              <ProtectedRoute>
                <AppLayout>
                  <OvenStatus />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <AppLayout>
                  <Dashboard />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/vision"
            element={
              <ProtectedRoute>
                <AppLayout>
                  <Vision />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/camera-settings"
            element={
              <ProtectedRoute requiredRole="admin">
                <AppLayout>
                  <CameraSettings />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/logs"
            element={
              <ProtectedRoute>
                <AppLayout>
                  <Logs />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/sensors"
            element={
              <ProtectedRoute>
                <AppLayout>
                  <Sensors />
                </AppLayout>
              </ProtectedRoute>
            }
          />

          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
        </AppDataProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
